import { render, staticRenderFns } from "./CiccRedirect.vue?vue&type=template&id=0bf5c7ca&scoped=true"
import script from "./CiccRedirect.vue?vue&type=script&lang=js"
export * from "./CiccRedirect.vue?vue&type=script&lang=js"
import style0 from "./CiccRedirect.vue?vue&type=style&index=0&id=0bf5c7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5c7ca",
  null
  
)

export default component.exports